import { createReducer, on } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import { ClaimAction } from './claim.actions';
import { ClaimListContent, ClaimViewResponse } from '../model/claim-model';

export const claimKey = 'claim';

export interface ClaimState {
  claimView: ClaimViewResponse;
  claimList: Pagination<ClaimListContent>;
}

export const initialState: ClaimState = {
  claimView: null,
  claimList: null
};

export const claimReducer = createReducer<ClaimState>(
  initialState,
  on(ClaimAction.claimListResponse, (state, { response }) => {
    return { ...state, claimList: response };
  }),
  on(ClaimAction.claimViewResponse, (state, { response }) => {
    return { ...state, claimView: response };
  }),
  on(ClaimAction.resetClaimView, (state) => {
    return { ...state, claimView: null };
  }),
  on(ClaimAction.resetClaimList, (state) => {
    return { ...state, claimList: null };
  })
);
